export const getTimeDifferenceInHours = (date: string): number =>
  Math.abs((new Date().getTime() - new Date(date).getTime()) / 1000 / 60 / 60);

export const getTimeDifferenceInDays = (date: string): number =>
  Math.abs(
    (new Date().getTime() - new Date(date).getTime()) / 1000 / 60 / 60 / 24
  );

export const getActiveUntilTimeDifferenceInDays = (
  activeUntil: string
): number =>
  (new Date(activeUntil).getTime() - new Date().getTime()) /
  1000 /
  60 /
  60 /
  24;
